import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../../core/layout/Dialog';
import { Link } from 'react-router';
import Button from '../../../../core/form/Button';

const WarningContractBlockDialog = (props) => (
  <Dialog
    title="Overdue payments"
    onCancel={props.onClose}
    actions={[<Button icon="warning" onClick={props.onClose} key="onOk" label="OK" />]}
    isOpen={props.isOpen}
  >
    {(props.daysUntilBlock === 16 ||
      props.daysUntilBlock === 12 ||
      props.daysUntilBlock === 9 ||
      props.daysUntilBlock <= 4) && (
      <p>
        <h3>Hi, how are you?</h3>
        We have found that your last bill is still open. You can find the payment link in the{' '}
        <Link to="/billing">
          <b>Billing</b>
        </Link>{' '}
        menu.
        <br />
        <br />
        In case of any doubt, we are here to help you by{' '}
        <a href="mailto:financeiro@flexge.com">financeiro@flexge.com</a> or{' '}
        <a href="https://api.whatsapp.com/send?phone=553491530981">whatsapp (+553491530981)</a>.
        {props.daysUntilBlock <= 12 && (
          <>
            <br />
            <br />
            <p>
              Your contract are going to be blocked in <b>{props.daysUntilBlock} days</b>.
            </p>
          </>
        )}
      </p>
    )}
  </Dialog>
);

WarningContractBlockDialog.propTypes = {
  overdueBills: PropTypes.number.isRequired,
  daysUntilBlock: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

WarningContractBlockDialog.defaultProps = {
  isOpen: false,
};

export default WarningContractBlockDialog;
